import type { ListItemProps } from '../../list-item.types'
import { ListItemIcon } from '../list-item-icon'
import * as Comp from './list-item-header.styles'

type ListItemHeaderProps = ListItemProps & {
  children: React.ReactNode
  testID?: string
}

export const ListItemHeader = (props: ListItemHeaderProps) => {
  const { children, testID } = props
  return (
    <Comp.Header testID={testID}>
      {children}
      <ListItemIcon
        symbol="rdicon-chevron-right"
        size="extra-small"
        color="colorTextNeutralDefault"
        testID="list-item-chevron-right"
      />
    </Comp.Header>
  )
}
